import { createIcon } from '../createIcon.tsx';

export const SearchIcon = createIcon(
	'SearchIcon',
	<>
		<circle cx="11" cy="11" r="8" />
		<path d="m21 21-4.35-4.35" />
	</>,
);
